import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { annonceService } from '../../api';
import './Annonce.css';
import Header from '../Header/Header';
import { FiMapPin, FiHeart, FiStar, FiPlusCircle } from 'react-icons/fi';
import Footer from '../footer/Footer';
import Categorie from '../Categorie/Categorie';

const Annonce = () => {
  const [annoncesData, setAnnoncesData] = useState({
    data: [],
    current_page: 1,
    last_page: 1,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [imageErrors, setImageErrors] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAllAnnonces = async () => {
      try {
        setLoading(true);
        
        console.log('🔍 Début récupération de TOUTES les annonces...');
        
        let allAnnonces = [];
        let currentPage = 1;
        let hasMoreData = true;
        
        while (hasMoreData) {
          try {
            console.log(`📄 Récupération page ${currentPage}...`);
            const response = await annonceService.getAll(currentPage);
            
            console.log(`📊 Réponse page ${currentPage}:`, response);
            
            let annoncesPage = [];
            
            if (response) {
              if (Array.isArray(response.data)) {
                annoncesPage = response.data;
              }
              else if (response.data && response.data.data && Array.isArray(response.data.data)) {
                annoncesPage = response.data.data;
              }
              else if (response.data && response.data.annonces && Array.isArray(response.data.annonces)) {
                annoncesPage = response.data.annonces;
              }
              else if (Array.isArray(response)) {
                annoncesPage = response;
              }
            }
            
            console.log(`✅ Page ${currentPage}: ${annoncesPage.length} annonces trouvées`);
            
            if (annoncesPage.length > 0) {
              const annoncesAvecImages = annoncesPage.map(annonce => {
                const annonceAvecImage = { ...annonce };
                
                if (annonce.image) {
                  const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
                  
                  if (annonce.image.startsWith('http')) {
                    annonceAvecImage.imageUrl = annonce.image;
                  } else {
                    annonceAvecImage.imageUrl = `${baseUrl}/storage/${
                      annonce.image.startsWith('storage/') 
                        ? annonce.image.replace('storage/', '') 
                        : annonce.image
                    }`;
                  }
                } else {
                  annonceAvecImage.imageUrl = '/default-annonce.jpg';
                }
                
                console.log(`Annonce ${annonce.id} - URL image: ${annonceAvecImage.imageUrl}`);
                return annonceAvecImage;
              });
              
              allAnnonces = [...allAnnonces, ...annoncesAvecImages];
            }
            
            const totalPages = response?.data?.last_page || 
                              response?.last_page || 
                              response?.data?.meta?.last_page || 
                              1;
            
            console.log(`📊 Total pages: ${totalPages}, Page actuelle: ${currentPage}`);
            
            if (currentPage >= totalPages || annoncesPage.length === 0) {
              hasMoreData = false;
              console.log(`🛑 Fin de la pagination à la page ${currentPage}`);
            } else {
              currentPage++;
            }
            
          } catch (pageError) {
            console.error(`❌ Erreur page ${currentPage}:`, pageError);
            hasMoreData = false;
          }
        }
        
        console.log(`✅ Total récupéré: ${allAnnonces.length} annonces`);
        
        allAnnonces.sort((a, b) => {
          const dateA = new Date(a.created_at || a.date_creation || 0);
          const dateB = new Date(b.created_at || b.date_creation || 0);
          return dateB - dateA;
        });
        
        setAnnoncesData({
          data: allAnnonces,
          current_page: 1,
          last_page: 1,
        });
        
      } catch (err) {
        console.error('❌ Erreur globale:', err);
        setError(err.message || 'Erreur lors du chargement des annonces');
        
        try {
          console.log('🔄 Tentative de récupération simple (première page)...');
          const fallbackResponse = await annonceService.getAll(1);
          
          let fallbackAnnonces = [];
          if (fallbackResponse) {
            if (Array.isArray(fallbackResponse.data)) {
              fallbackAnnonces = fallbackResponse.data;
            } else if (fallbackResponse.data && fallbackResponse.data.data && Array.isArray(fallbackResponse.data.data)) {
              fallbackAnnonces = fallbackResponse.data.data;
            }
          }
          
          const annoncesAvecImages = fallbackAnnonces.map(annonce => {
            const annonceAvecImage = { ...annonce };
            
            if (annonce.image) {
              const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
              
              if (annonce.image.startsWith('http')) {
                annonceAvecImage.imageUrl = annonce.image;
              } else {
                annonceAvecImage.imageUrl = `${baseUrl}/storage/${
                  annonce.image.startsWith('storage/') 
                    ? annonce.image.replace('storage/', '') 
                    : annonce.image
                }`;
              }
            } else {
              annonceAvecImage.imageUrl = '/default-annonce.jpg';
            }
            
            return annonceAvecImage;
          });
          
          setAnnoncesData({
            data: annoncesAvecImages,
            current_page: 1,
            last_page: 1,
          });
        } catch (fallbackError) {
          console.error('❌ Erreur fallback:', fallbackError);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchAllAnnonces();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 0) {
      return "Aujourd'hui";
    } else if (diffDays === 1) {
      return "Hier";
    } else if (diffDays < 7) {
      return `Il y a ${diffDays} jours`;
    } else if (diffDays < 30) {
      const weeks = Math.floor(diffDays / 7);
      return `Il y a ${weeks} semaine${weeks > 1 ? 's' : ''}`;
    } else {
      return date.toLocaleDateString('fr-FR', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    }
  };

  const handleImageError = (annonceId) => {
    console.error(`Image error for annonce ${annonceId}`);
    setImageErrors(prev => ({ ...prev, [annonceId]: true }));
  };

  const getImageUrl = (annonce) => {
    if (imageErrors[annonce.id]) {
      return '/default-annonce.jpg';
    }
    
    if (annonce.imageUrl) {
      return annonce.imageUrl;
    }
    
    if (annonce.image) {
      const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
      return `${baseUrl}/storage/${
        annonce.image.startsWith('storage/') 
          ? annonce.image.replace('storage/', '') 
          : annonce.image
      }`;
    }
    
    return '/default-annonce.jpg';
  };

  if (loading) {
    return (
      <div className="annonce-page-container">
        <Header />
        <div className="annonce-loading-container">
          <div className="annonce-loading-spinner"></div>
          <p>Chargement des annonces...</p>
        </div>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="annonce-page-container">
        <Header />
        <div className="annonce-error-container">
          <p className="annonce-error-message">Erreur: {error}</p>
          <button onClick={() => window.location.reload()} className="annonce-retry-button">
            Réessayer
          </button>
        </div>
        <Footer />
      </div>
    );
  }

  const annonces = annoncesData.data || [];

  return (
    <div className="annonce-page-container">
      <Header />
      
      <div className="annonce-categorie-section">
        <Categorie />
      </div>

      <div className="annonce-main-section">
        <div className="annonce-header-section">
          <h1>Annonces disponibles</h1>
          <p>{annonces.length} annonce{annonces.length > 1 ? 's' : ''} trouvée{annonces.length > 1 ? 's' : ''}</p>
        </div>
        
        <div className="annonce-cards-grid">
          {annonces.length > 0 ? (
            annonces.map((annonce) => {
              const imageUrl = getImageUrl(annonce);
              const datePublication = formatDate(annonce.created_at || annonce.date_creation);
              
              return (
                <div 
                  key={annonce.id} 
                  className="annonce-card-item"
                  onClick={() => navigate(`/annonces/${annonce.id}`)}
                >
                  <div className="annonce-card-image-container">
                    <img 
                      src={imageUrl}
                      alt={annonce.titre}
                      className="annonce-card-image"
                      onError={() => {
                        console.error(`Échec chargement image annonce ${annonce.id}: ${imageUrl}`);
                        handleImageError(annonce.id);
                      }}
                      onLoad={() => console.log(`Image chargée pour annonce ${annonce.id}: ${imageUrl}`)}
                    />
                    <button 
                      className="annonce-wishlist-btn" 
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <FiHeart className="annonce-icon" />
                    </button>
                    
                    {(annonce.created_at || annonce.date_creation) && 
                     (new Date() - new Date(annonce.created_at || annonce.date_creation)) < (7 * 24 * 60 * 60 * 1000) && (
                      <div className="annonce-new-badge">
                        Nouveau
                      </div>
                    )}
                  </div>
                  
                  <div className="annonce-card-content">
                    <div className="annonce-card-header">
                      <h3>{annonce.titre}</h3>
                      <div className="annonce-rating">
                        <FiStar className="annonce-icon" />
                        <span>4.8</span>
                      </div>
                    </div>
                    
                    <p className="annonce-location">
                      <FiMapPin className="annonce-icon" /> {annonce.ville}
                    </p>
                    
                    {datePublication && (
                      <p className="annonce-publication-date">
                        Publié {datePublication}
                      </p>
                    )}
                    
                    <p className="annonce-price">
                      {annonce.prix} € <span>par service</span>
                    </p>
                    
                    <div className="annonce-service-tag">
                      {annonce.sous_service?.nom || 'Non catégorisé'}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="annonce-no-results">
              <p>Aucune annonce disponible pour le moment</p>
            </div>
          )}
        </div>
      </div>
      
      <div className="annonce-footer-spacer"></div>
      <Footer />
    </div>
  );
};

export default Annonce;